import { render } from "./ContextMenuButton.vue?vue&type=template&id=11140c10&scoped=true&ts=true"
import script from "./ContextMenuButton.vue?vue&type=script&lang=ts"
export * from "./ContextMenuButton.vue?vue&type=script&lang=ts"

import "./ContextMenuButton.vue?vue&type=style&index=0&id=11140c10&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11140c10"]])

export default __exports__